import React, { useCallback, useRef, useEffect, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';

import { IconType } from 'react-icons/lib';

import {
  Container,

} from './styles';



import { useAuth } from '../../hooks/Auth';

import { useModal } from '../../hooks/Modal';

import { usePages } from '../../hooks/Pages';
import { useLanguage } from '../../hooks/Language';

import api from '../../services/api';
import { hash, urlWebsite } from '../../config';

import { loadFromJson } from '../../utils/loadFromJson';
import LeiteEmPo from '../ComoEFeito/modules/LeiteEmPo';

interface IMenu {
  title: string;
  target: string;
  targetID: string;
  fluid: number;
  external: number;
  status: number;
}

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Vitalidade: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const data = [
    { img_style: { width: '60px' }, icon: '/apoio/recuperacao.png', title: 'RECUPERAÇÃO MUSCULAR', description: 'Cada porção do novo leite em pó CCGL contém uma dose concentrada de proteínas de alta qualidade, projetada para acelerar a recuperação muscular após cada treino intenso. Os aminoácidos essenciais presentes garantem uma reparação celular eficaz, permitindo que seus músculos se recuperem mais rapidamente para enfrentar os desafios seguintes.' },
    { img_style: { width: '60px' }, icon: '/apoio/ganho-muscular.png', title: 'GANHO MUSCULAR', description: 'Não se trata apenas de recuperação, mas também de crescimento. Com 12 gramas de proteína por porção, nosso leite em pó fornece o combustível necessário para auxiliar o seu desenvolvimento muscular após exercício físico.' },
    { img_style: { width: '60px' }, icon: '/apoio/articular.png', title: 'SAÚDE ARTICULAR', description: 'Combinamos os benefícios da proteína com nutrientes essenciais para a saúde óssea e articular (vitamina D, cálcio, magnésio), proporcionando uma fundação robusta para suportar o impacto de treinos intensos. Fortaleça seus ossos e articulações, garantindo sua jornada de condicionamento físico.' },

  ]
  const currentData = data?.[currentIndex] || {};

  return (<>


    <Container className='gap-bg column  ' style={{ minHeight: '80vh', background: 'none', zIndex: 900 }}>

      <div className='row full-width fadeIn '>
        <img loading='lazy' src='/apoio/vitalidade/ccgl.png' className='max-400' />
      </div>
      <div className='max-1400 gap-bg column fadeIn ' style={{ marginTop: '50px' }}>
        <img loading='lazy' src='/apoio/pro/imagens-pagina3.png' className='max-1400 computerOnly' />
        <img loading='lazy' src='/apoio/pro/pag3-mobile.png' className='max-1400 mobileOnly' />





        <div className='row full-width fadeIn '>
          <img loading='lazy' src='/apoio/vitalidade/desempenhov2.png' className='max-1000' />


        </div>
        <p className='contentParagraphSimple text-center max-1200'>
          Para você que pratica exercícios e busca ganho muscular, o leite em pó proteico CCGL é uma fonte poderosa com 12 gramas de proteína por porção, enriquecido com nutrientes essenciais para impulsionar seu desempenho atlético a novos patamares
        </p>
        <div className='column computerOnlyFlex'>

          {data?.map(item => {
            return <div className='row fadeIn   row-start row-to-column max-1200 gap-md pad-sm' style={{ alignItems: 'flex-start' }}>
              <div style={{ width: '70px', minWidth: '70px', display: 'flex', marginTop: '7px', alignItems: 'flex-start', justifyContent: 'center' }}><img loading='lazy' className='max-100' style={{ ...item?.img_style }} src={item?.icon} /></div>
              <p className='contentParagraphSimple text-left max-1200'>
                <strong className='color2'>{item?.title}</strong> <br />
                <p dangerouslySetInnerHTML={{ __html: item?.description }} />  </p>
            </div>


          })}

        </div>

        <div className='mobileOnlyFlex column'>

          <div className='row gap-xs'>

            {data?.map((item, index) => {

              return <div style={{ borderRadius: '7.5px', width: '60px', height: '60px', display: 'flex', justifyContent: 'center', alignItems: 'center' }} className={`pad-xs fadeIn  ${index === currentIndex ? 'background1 ' : 'none'}`}>
                <img loading='lazy' onClick={() => setCurrentIndex(index)} style={{ maxHeight: '50px', width: 'auto' }} src={item?.icon} /></div>
            })}


          </div>

          <div key={currentData?.title} className='row fadeIn  row-start rcolumn max-1000 gap-md pad-sm'>
            <p className='contentParagraphSimple text-left max-1000'>
              <strong className='color2'>{currentData?.title}</strong> <br />
              <p  > {currentData?.description}</p></p>
          </div>


        </div>


      </div>
      <div className='row fadeIn   row  row-to-column max-800 gap-md pad-sm' style={{ alignItems: 'center' }}>
        <img loading='lazy' className='max-300' src={'/apoio/vitalidade/embalagem.png'} />
        <div> <p className='contentParagraphSimple text-left max-1200'  >

          Escolha mais do que uma bebida.<br />
          Escolha uma parceria na sua<br />
          jornada de exercícios físicos.<br />
          Elevando seu desempenho, nutrindo<br />
          seu corpo e alimentando sua determinação.<br />
          Desperte o atleta em você com<br />
          nosso leite em pó rico em proteínas


        </p><br />
          <strong className='color2' style={{ fontSize: '28px' }}>SEU SUCESSO COMEÇA<br />
            COM O PRIMEIRO GOLE!</strong>
        </div>
      </div>


    </Container>

  </>
  );
};
export default Vitalidade;
